/* eslint-disable no-useless-catch */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */

import { API } from "../utils/AxiosInstance";

export enum AuthenticationActionTypes {
    LOGGED_OUT = 'authentication/LOGGED_OUT'
}

export function login(email: string, password: string, redirectUrl?: string) {
    return async () => {
        try {
            const response = await API.post('/sessions', { email, password })
            localStorage.setItem('token', response.data.token as string);
            if (redirectUrl) {
                if (window.location.origin) {
                    window.location.href = window.location.origin + redirectUrl;
                } else {
                    window.location.href = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port: '') + redirectUrl;
                }
                
            } else {
                window.location.href = "/app/dashboard";
            }
            
        } catch (error) {
            throw error;
        }
    }
}

export function logout() {
    return async () => {
        try {
            await API.delete('/sessions');
            localStorage.clear();
            window.location.href = "/";
        } catch {
            localStorage.clear();
            window.location.href = "/";
        }
    }
}

export function loginFromSolera(code: string) {
    return async () => {
        try {
            const response = await API.post('/sessions/solera', { code });
            localStorage.setItem('token', response.data.token as string);
        } catch (error) {
            throw error;
        }
    }
}
